// @ts-nocheck
import React from 'react';
import styled from 'styled-components';
import { useFilters, useRowSelect, useSortBy, useTable, usePagination, useExpanded, useGroupBy } from 'react-table';
//
import TableActions from 'components/deal-list/table-actions';
import Table from 'components/table/table';
import Pagination from 'components/deal-list/pagination';
import { renderSortIcon } from 'components/deal-list/helpers';
import IndeterminateCheckbox from 'components/deal-list/indeterminate-checkbox';
import DealSearch from 'components/deal-search';

interface ITableProps {
  columns: HeaderGroup<object>;
  data: IDeal[];
}

const Title = styled.h2`
  font-weight: 600;
  font-size: 22px;
  margin: 0;
`;

const DashboardHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 130px;
`;

const ColumnHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ColumnHeaderLabel = styled.span``;

const DealSearchContainer = styled.div`
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
`;

const NoDealsMessage = styled.td`
  text-align: center;
  padding: 32px !important;
`;

function renderHeaderDivComponent() {
  return <div />;
}

function renderCellDivComponent(row: IRowType) {
  return (
    <div>
      <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
    </div>
  );
}

export default ({ columns, data }: ITableProps) => {
  const {
    state: { pageIndex },
    selectedFlatRows,
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 15, sortBy: [{ id: 'createdOn', desc: true }] },
    },
    useGroupBy,
    useExpanded,
    useFilters,
    useSortBy,
    useRowSelect,
    usePagination,
    hooks => {
      hooks.flatColumns.push((cols: string[]) => [
        {
          id: 'selection',
          Header: () => renderHeaderDivComponent(),
          Cell: ({ row }: IRowType) => renderCellDivComponent(row),
        },
        ...cols,
      ]);
    }
  );

  return (
    <div>
      <DashboardHeader>
        <DealSearchContainer>
          <Title>Dashboard</Title>
          <DealSearch />
        </DealSearchContainer>
        <TableActions selectedRows={selectedFlatRows} />
      </DashboardHeader>
      <Table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup: HeaderGroup<object>) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  <ColumnHeader>
                    <ColumnHeaderLabel>{column.render('Header')}</ColumnHeaderLabel>
                    {renderSortIcon(column)}
                  </ColumnHeader>
                </th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody {...getTableBodyProps()}>
          {page.length ? (
            page.map((row: IRowType) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map(cell => {
                    return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>;
                  })}
                </tr>
              );
            })
          ) : (
            <tr>
              <NoDealsMessage colSpan={100}>No deals</NoDealsMessage>
            </tr>
          )}
        </tbody>
      </Table>

      <Pagination
        canNextPage={canNextPage}
        canPreviousPage={canPreviousPage}
        gotoPage={gotoPage}
        nextPage={nextPage}
        pageCount={pageCount}
        pageIndex={pageIndex}
        previousPage={previousPage}
      />
    </div>
  );
};
